@if (isLoading()) {
  <div
    role="status"
    aria-label="Loading"
    class="{{ layout() }} flex items-center justify-center z-1 inset-0 bg-dark/50"
  >
    <div
      aria-hidden="true"
      class="w-[50px] h-[50px] animate-spin rounded-[50%] border-[5px] border-solid border-white border-t-primary border-t-[#33453f]"
    ></div>
  </div>
}
